<mat-accordion class="management-accordion">
    <mat-expansion-panel expanded="true" hideToggle class="panel-form">
        <mat-expansion-panel-header collapsedHeight="48px" expandedHeight="48px" class="detail-header">
            <div class="detail-header-container">
                <mat-panel-title (click)="$event.stopPropagation()">
                    <p class="title">Abonnements</p>
                </mat-panel-title>
            </div>
        </mat-expansion-panel-header>
        <div class="subscriptions-container">
            <div class="form-panel-container">
                <div class="form-container">
                    <form [formGroup]="formGroup">
                        <div class="param-form-item form-item">
                            <mat-checkbox class="accent-button" matInput formControlName="hubPowerQuery" (change)="onCheckboxChanged(ServiceCodes.HubPowerQuery, $event)">
                                Accès à la source de données Power Query
                            </mat-checkbox>
                        </div>
                        <div class="param-form-item form-item">
                            <mat-checkbox class="accent-button" matInput formControlName="hubApiApplication" (change)="onCheckboxChanged(ServiceCodes.HubApiApplication, $event)">
                                Accès aux API par une application
                            </mat-checkbox>
                        </div>
                        <div class="param-form-item form-item">
                            <mat-checkbox class="accent-button" matInput formControlName="hubDashBoard" (change)="onCheckboxChanged(ServiceCodes.HubDashBoard, $event)">
                                Accès à la supervision
                            </mat-checkbox>
                        </div>
                        <div class="param-form-item form-item">
                            <mat-checkbox class="accent-button" matInput formControlName="hubEncryption" (change)="onCheckboxChanged(ServiceCodes.HubEncryption, $event)">
                                Chiffrement des données
                            </mat-checkbox>
                        </div>
                        <div class="param-form-item form-item">
                            <mat-checkbox class="accent-button" matInput formControlName="hubHdsEncryption" (change)="onCheckboxChanged(ServiceCodes.HubHdsEncryption, $event)">
                                Chiffrement des données HDS
                            </mat-checkbox>
                        </div>
                        <div class="param-form-item form-item">
                            <mat-checkbox class="accent-button" matInput formControlName="hubSmsSending" (change)="onCheckboxChanged(ServiceCodes.HubSmsSending, $event)">
                                Envoi de SMS
                            </mat-checkbox>
                        </div>
                        <div class="param-form-item form-item">
                            <mat-checkbox class="accent-button" matInput formControlName="hubTchat" (change)="onCheckboxChanged(ServiceCodes.HubTchat, $event)">Tchat</mat-checkbox>
                        </div>
                    </form>
                </div>
                <div class="buttons-container">
                    <button mat-stroked-button class="accent-button" (click)="cancel()" [disabled]="!isModified" [ngClass]="{ disabled: !isModified }">Annuler</button>
                    <button mat-raised-button class="accent-button" (click)="save()" [disabled]="!isModified" [ngClass]="{ disabled: !isModified }">Enregistrer</button>
                </div>
            </div>
        </div>
    </mat-expansion-panel>
</mat-accordion>
